import { useQuery } from "@tanstack/react-query";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";
import { integrationQueryKeys } from "@/integration/data/integrationQueryKeys";

export function useGithubRepositories() {
  const { org } = useEnvironment();
  return useQuery({
    queryKey: integrationQueryKeys.githubRepositories(org.id),
    queryFn: async () => {
      const res = await api.get<`/orgs/:orgId/github/connection/repos`>(
        `/orgs/${org.id}/github/connection/repos`,
      );
      return res.data;
    },
    retry: 2,
  });
}
